module.exports = __webpack_public_path__ + "img/home web@2x.1990c2bb.png";